import React from 'react'

const Footer = () => {
    return (
        <div className="text-center p-4" style={{ "backgroundColor": "#0034" }}>
            © 2022 Copyright:
            <a className=" text-green-600 font-bold" href="https://go-green-10.vercel.app/">Go-Green</a>
        </div>
    )
}

export default Footer